import { render, staticRenderFns } from "./BrsNihonView.vue?vue&type=template&id=e89caf4e&scoped=true&"
import script from "./BrsNihonView.vue?vue&type=script&lang=js&"
export * from "./BrsNihonView.vue?vue&type=script&lang=js&"
import style0 from "./BrsNihonView.vue?vue&type=style&index=0&id=e89caf4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89caf4e",
  null
  
)

export default component.exports